var helper = {
    splitTypes(list) {
        let output_sales = {};
        let output_stocks = {};
        for (let i = 0; i < list.length; i++) {
            if (list[i].sellout_type === "Vendas") {
                if (output_sales[list[i].retailer] === undefined) {
                    //Insert a new retailer key and in same level a data key with an empty array
                    output_sales[list[i].retailer] = { name: list[i].retailer, count: 1, date: list[i].date }
                }
                else {
                    //If retailer already exists, increment count and update date
                    output_sales[list[i].retailer]['count'] += 1
                }
            }
            if (list[i].sellout_type === "Stocks") {
                if (output_stocks[list[i].retailer] === undefined) {
                    //Insert a new retailer key and in same level a data key with an empty array
                    output_stocks[list[i].retailer] = { name: list[i].retailer, count: 1, date: list[i].date }
                }
                else {
                    //If retailer already exists, increment count and update date
                    output_stocks[list[i].retailer]['count'] += 1
                }
            }
        }
        return {
            sales: output_sales,
            stocks: output_stocks
        }
    }

}


export default helper;
